import type { IconSvgProps } from '../Icon.types';

export const CheckSimple = ({ width, height }: IconSvgProps) => (
  <svg width={width} height={height} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <g id="Check">
      <path
        id="Vector"
        d="M10.7653 3.64034L4.76531 9.64034C4.73048 9.6752 4.68912 9.70286 4.6436 9.72174C4.59807 9.74061 4.54928 9.75032 4.49999 9.75032C4.45071 9.75032 4.40192 9.74061 4.35639 9.72174C4.31087 9.70286 4.26951 9.6752 4.23468 9.64034L1.60968 7.01534C1.53932 6.94497 1.49979 6.84954 1.49979 6.75003C1.49979 6.65051 1.53932 6.55508 1.60968 6.48471C1.68005 6.41435 1.77548 6.37482 1.87499 6.37482C1.97451 6.37482 2.06994 6.41435 2.14031 6.48471L4.49999 8.84487L10.2347 3.10971C10.305 3.03935 10.4005 2.99982 10.5 2.99982C10.5995 2.99982 10.6949 3.03935 10.7653 3.10971C10.8357 3.18008 10.8752 3.27551 10.8752 3.37503C10.8752 3.47454 10.8357 3.56997 10.7653 3.64034Z"
      />
    </g>
  </svg>
);
